import locale from "../utils/locale";

let language = window.localStorage.getItem("language") || "zh";


let store_locale = {
	state: ()=>{
		return {
            language: language
		}
	},
    getters: {
        language(state, getters) {
            return state.language;
        },
	},
	mutations: {
		
	},
	actions: {
		setLanguage({state}, language) {
            state.language = language;
            window.localStorage.setItem("language", language);
        }
	}
}

for (let key in locale) {
    store_locale.getters[key] = function(state, getters) {
        return locale[key][state.language]
    }

}

export default store_locale;